import styled from '@emotion/styled';
import { RadioGroup } from '@mui/material';

export const Container = styled(RadioGroup)``;
